import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-377a6941"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "geomapper-container" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "📍 GeoMapper", -1))
const _hoisted_4 = { class: "menu-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "User Settings", -1))
const _hoisted_6 = { class: "menu-toggle" }
const _hoisted_7 = { class: "menu-content" }
const _hoisted_8 = { class: "input-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-bottom":"8px","color":"#333","font-weight":"500"} }, "Date Range Filter:", -1))
const _hoisted_10 = { style: {"display":"flex","flex-direction":"column","gap":"8px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-bottom":"4px","font-size":"12px","color":"#666"} }, "Start Date:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-bottom":"4px","font-size":"12px","color":"#666"} }, "End Date:", -1))
const _hoisted_13 = {
  key: 0,
  class: "input-section"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"block","margin-bottom":"8px","color":"#333","font-weight":"500"} }, "Filter by Year:", -1))
const _hoisted_15 = { class: "radio-group" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "menu-section" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Developer Settings", -1))
const _hoisted_19 = { class: "menu-toggle" }
const _hoisted_20 = { class: "menu-content" }
const _hoisted_21 = { class: "input-section" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "addresses" }, "Addresses (one per line):", -1))
const _hoisted_23 = {
  class: "input-section",
  style: {"margin-bottom":"20px"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Import CSV (DATE, ADDRESS):", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"color":"black","font-size":"12px"} }, "CSV format: DATE,ADDRESS (e.g., 2024-01-15,123 Main St, New York, NY)", -1))
const _hoisted_26 = { class: "button-group" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  class: "saved-files-section",
  style: {"margin-bottom":"20px","background":"white","padding":"15px","border-radius":"6px","border":"1px solid #ddd"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"10px"} }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"margin":"0","font-size":"14px","color":"#333"} }, "Local JSON Files")
], -1))
const _hoisted_30 = {
  key: 0,
  style: {"color":"#666","font-size":"12px","padding":"10px 0"}
}
const _hoisted_31 = {
  key: 1,
  class: "saved-files-list",
  style: {"max-height":"200px","overflow-y":"auto"}
}
const _hoisted_32 = { style: {"flex":"1","min-width":"0"} }
const _hoisted_33 = { style: {"font-weight":"500","font-size":"13px","color":"#333","margin-bottom":"2px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_34 = { style: {"font-size":"11px","color":"#666"} }
const _hoisted_35 = { style: {"display":"flex","gap":"6px","margin-left":"10px"} }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "stats" }
const _hoisted_38 = { class: "stats-item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stats-label" }, "Total Addresses:", -1))
const _hoisted_40 = { class: "stats-value" }
const _hoisted_41 = { class: "stats-item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stats-label" }, "Mapped:", -1))
const _hoisted_43 = { class: "stats-value" }
const _hoisted_44 = { class: "stats-item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stats-label" }, "Failed:", -1))
const _hoisted_46 = { class: "stats-value" }
const _hoisted_47 = { style: {"display":"flex","justify-content":"space-between","margin-bottom":"5px"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px","color":"#666"} }, "Processing...", -1))
const _hoisted_49 = { style: {"font-size":"13px","color":"#666"} }
const _hoisted_50 = { class: "progress-bar" }
const _hoisted_51 = { class: "progress-text" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Ignored Addresses:", -1))
const _hoisted_53 = { id: "errorList" }
const _hoisted_54 = {
  key: 0,
  class: "error-item"
}
const _hoisted_55 = { class: "map-container" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "−", -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "⌂", -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "📍", -1))
const _hoisted_63 = [
  _hoisted_62
]

import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useFirebaseConfig } from '../../composables/useFirebaseConfig';
import locationsTestData from './locationsTest.json';
import customers2022Data from './customers2022.json';
import customers2023Data from './customers2023.json';
import customers2024Data from './customers2024.json';
import customers2025aData from './customers2025a.json';
import customers2025bData from './customers2025b.json';
import customers2026Data from './customers2026.json';

interface Location {
    address: string;
    date: string | null;
    location: google.maps.LatLng;
    formatted: string;
}

interface AddressWithDate {
    date: string;
    address: string;
}

interface GeocodeError {
    address: string;
    date: string | null;
    status: string;
}

interface DateFilter {
    startDate: string;
    endDate: string;
}

interface SavedFile {
    id: string;
    name: string;
    timestamp: number;
    locationCount: number;
    data: any[];
}


// Get API key from Firebase
interface LocalJsonFile {
    name: string;
    locationCount: number;
    data: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GeoMapper',
  setup(__props) {

const { googleApiKey, isLoading: isLoadingApiKey } = useFirebaseConfig();
const apiKey = ref<string>('');

// Watch for API key from Firebase and update when available
watch(googleApiKey, (newKey) => {
    if (newKey) {
        apiKey.value = newKey;
        // If we have a key and haven't loaded initial data yet, load default data (2026)
        if (apiKey.value.trim() && !hasLoadedInitialData.value) {
            loadMapData();
        }
    }
}, { immediate: true });
const addressesText = ref<string>('');
const mapContainer = ref<HTMLElement | null>(null);
const jsonFileInput = ref<HTMLInputElement | null>(null);

const map = ref<google.maps.Map | null>(null);
const geocoder = ref<google.maps.Geocoder | null>(null);
const markers = ref<google.maps.Marker[]>([]);
const markerCluster = ref<any>(null);
const savedLocations = ref<Location[]>([]);
const hasLoadedInitialData = ref<boolean>(false);
const centerMarker = ref<google.maps.Marker | null>(null);
const centerInfoWindow = ref<google.maps.InfoWindow | null>(null);

const totalCount = ref<number>(0);
const mappedCount = ref<number>(0);
const failedCount = ref<number>(0);
const isProcessing = ref<boolean>(false);
const progressPercent = ref<number>(0);
const progressText = ref<string>('Initializing...');
const errors = ref<GeocodeError[]>([]);
const startDate = ref<string>('');
const endDate = ref<string>('');
const currentDateFilter = ref<DateFilter | null>(null);
const savedFiles = ref<SavedFile[]>([]);
const userSettingsOpen = ref<boolean>(true);
const developerSettingsOpen = ref<boolean>(false);
// Initialize router at top level
const route = useRoute();
const router = useRouter();

const selectedYear = ref<string>('');

// Year-specific customer data
const yearDataMap: Record<string, any[]> = {
    '2022': customers2022Data as any[],
    '2023': customers2023Data as any[],
    '2024': customers2024Data as any[],
    '2025a': customers2025aData as any[],
    '2025b': customers2025bData as any[],
    '2026': customers2026Data as any[]
};

// Local JSON files available in the same folder
const localJsonFiles = ref<LocalJsonFile[]>([
    {
        name: 'customers2022.json',
        locationCount: Array.isArray(customers2022Data) ? customers2022Data.length : 0,
        data: customers2022Data as any[]
    },
    {
        name: 'customers2023.json',
        locationCount: Array.isArray(customers2023Data) ? customers2023Data.length : 0,
        data: customers2023Data as any[]
    },
    {
        name: 'customers2024.json',
        locationCount: Array.isArray(customers2024Data) ? customers2024Data.length : 0,
        data: customers2024Data as any[]
    },
    {
        name: 'customers2025a.json',
        locationCount: Array.isArray(customers2025aData) ? customers2025aData.length : 0,
        data: customers2025aData as any[]
    },
    {
        name: 'customers2025b.json',
        locationCount: Array.isArray(customers2025bData) ? customers2025bData.length : 0,
        data: customers2025bData as any[]
    },
    {
        name: 'customers2026.json',
        locationCount: Array.isArray(customers2026Data) ? customers2026Data.length : 0,
        data: customers2026Data as any[]
    },
    {
        name: 'locationsTest.json',
        locationCount: Array.isArray(locationsTestData) ? locationsTestData.length : 0,
        data: locationsTestData as any[]
    }
]);

const hasDateData = computed(() => {
    return savedLocations.value.some(loc => loc.date);
});

const displayedErrors = computed(() => {
    return errors.value.slice(0, 50);
});

const filteredCountText = computed(() => {
    if (currentDateFilter.value && currentDateFilter.value.startDate && currentDateFilter.value.endDate) {
        const filtered = getFilteredLocations(savedLocations.value, currentDateFilter.value);
        return `Showing ${filtered.length} of ${savedLocations.value.length} locations`;
    }
    return `Showing all ${savedLocations.value.length} locations`;
});

// Get unique years from available year data files
const uniqueYears = computed(() => {
    return Object.keys(yearDataMap)
        .filter(year => Array.isArray(yearDataMap[year]) && yearDataMap[year].length > 0)
        .sort((a, b) => {
            // Sort 2025a and 2025b together, with 2025a before 2025b
            const aNum = a.replace(/[ab]/g, '');
            const bNum = b.replace(/[ab]/g, '');
            if (aNum !== bNum) {
                return parseInt(bNum) - parseInt(aNum);
            }
            // If same year number, sort by suffix (a before b)
            return a.localeCompare(b);
        });
});

// Load Google Maps API
function loadGoogleMaps(key: string): Promise<void> {
    return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=geometry`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Google Maps API'));
        document.head.appendChild(script);
    });
}

// Initialize map
function initMap(): void {
    if (!mapContainer.value) return;

    map.value = new google.maps.Map(mapContainer.value, {
        zoom: 2,
        center: { lat: 20, lng: 0 },
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true
    });

    geocoder.value = new google.maps.Geocoder();
}

// Zoom functions
function zoomIn(): void {
    if (map.value) {
        const currentZoom = map.value.getZoom() || 2;
        map.value.setZoom(currentZoom + 1);
    }
}

function zoomOut(): void {
    if (map.value) {
        const currentZoom = map.value.getZoom() || 2;
        map.value.setZoom(currentZoom - 1);
    }
}

function fitToMarkers(): void {
    if (!map.value || markers.value.length === 0) return;
    
    const bounds = new google.maps.LatLngBounds();
    markers.value.forEach(marker => {
        const position = marker.getPosition();
        if (position) {
            bounds.extend(position);
        }
    });
    
    map.value.fitBounds(bounds);
}

// Calculate the centroid (center) of all markers
function calculateCentroid(): google.maps.LatLng | null {
    if (markers.value.length === 0) {
        alert('No markers on the map. Please load some locations first.');
        return null;
    }

    let sumLat = 0;
    let sumLng = 0;
    let count = 0;

    markers.value.forEach(marker => {
        const position = marker.getPosition();
        if (position) {
            sumLat += position.lat();
            sumLng += position.lng();
            count++;
        }
    });

    if (count === 0) return null;

    return new google.maps.LatLng(sumLat / count, sumLng / count);
}

// Handle button click to show center location
function handleShowCenterLocation(): void {
    showCenterLocation(false);
}

// Show center location with reverse geocoding
async function showCenterLocation(autoCalculate: boolean = false): Promise<void> {
    if (!map.value || !geocoder.value) {
        if (!autoCalculate) {
            alert('Map not initialized. Please wait for the map to load.');
        }
        return;
    }

    const center = calculateCentroid();
    if (!center) return;

    // Remove previous center marker if it exists
    if (centerMarker.value) {
        centerMarker.value.setMap(null);
        centerMarker.value = null;
    }
    if (centerInfoWindow.value) {
        centerInfoWindow.value.close();
        centerInfoWindow.value = null;
    }

    // Reverse geocode to get the location name
    geocoder.value.geocode(
        { location: center },
        (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
            if (status === 'OK' && results && results[0]) {
                const locationName = results[0].formatted_address;
                
                // Create a special marker for the center
                const marker = new google.maps.Marker({
                    position: center,
                    map: map.value!,
                    title: `Center: ${locationName}`,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 10,
                        fillColor: '#4285f4',
                        fillOpacity: 1,
                        strokeColor: '#FFFFFF',
                        strokeWeight: 2
                    },
                    zIndex: google.maps.Marker.MAX_ZINDEX + 1,
                    animation: google.maps.Animation.BOUNCE
                });

                // Create info window with location details
                const infoContent = `
                    <div style="padding: 12px; min-width: 250px;">
                        <h3 style="margin: 0 0 8px 0; color: #333; font-size: 16px;">📍 Center Location</h3>
                        <div style="margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #e0e0e0;">
                            <strong style="color: #333; font-size: 14px; display: block; margin-bottom: 4px;">Address:</strong>
                            <span style="color: #666; font-size: 14px; line-height: 1.4;">${locationName}</span>
                        </div>
                        <p style="margin: 0 0 8px 0; color: #666; font-size: 12px;">
                            <strong>Coordinates:</strong> ${center.lat().toFixed(6)}, ${center.lng().toFixed(6)}
                        </p>
                        <p style="margin: 8px 0 0 0; color: #666; font-size: 12px;">
                            <strong>Based on:</strong> ${markers.value.length} marker(s)
                        </p>
                    </div>
                `;

                const infoWindow = new google.maps.InfoWindow({
                    content: infoContent
                });

                centerMarker.value = marker;
                centerInfoWindow.value = infoWindow;

                // Add click listener to open info window
                marker.addListener('click', () => {
                    infoWindow.open(map.value!, marker);
                });

                // Only open info window and center map if manually triggered (not auto-calculate)
                if (!autoCalculate) {
                    infoWindow.open(map.value!, marker);
                    map.value!.setCenter(center);
                    map.value!.setZoom(Math.max(map.value!.getZoom() || 10, 10));
                }

                // Stop bouncing after 2 seconds
                setTimeout(() => {
                    if (marker.getAnimation() !== null) {
                        marker.setAnimation(null);
                    }
                }, 2000);
            } else {
                // If reverse geocoding fails, still show the center with coordinates
                const marker = new google.maps.Marker({
                    position: center,
                    map: map.value!,
                    title: `Center: ${center.lat().toFixed(6)}, ${center.lng().toFixed(6)}`,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 10,
                        fillColor: '#4285f4',
                        fillOpacity: 1,
                        strokeColor: '#FFFFFF',
                        strokeWeight: 2
                    },
                    zIndex: google.maps.Marker.MAX_ZINDEX + 1,
                    animation: google.maps.Animation.BOUNCE
                });

                const infoContent = `
                    <div style="padding: 12px; min-width: 250px;">
                        <h3 style="margin: 0 0 8px 0; color: #333; font-size: 16px;">📍 Center Location</h3>
                        <div style="margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #e0e0e0;">
                            <strong style="color: #333; font-size: 14px; display: block; margin-bottom: 4px;">Address:</strong>
                            <span style="color: #666; font-size: 14px; line-height: 1.4;">${center.lat().toFixed(6)}, ${center.lng().toFixed(6)}</span>
                            <p style="margin: 4px 0 0 0; color: #999; font-size: 12px; font-style: italic;">
                                Location name not available
                            </p>
                        </div>
                        <p style="margin: 8px 0 0 0; color: #666; font-size: 12px;">
                            <strong>Based on:</strong> ${markers.value.length} marker(s)
                        </p>
                    </div>
                `;

                const infoWindow = new google.maps.InfoWindow({
                    content: infoContent
                });

                centerMarker.value = marker;
                centerInfoWindow.value = infoWindow;

                // Add click listener to open info window
                marker.addListener('click', () => {
                    infoWindow.open(map.value!, marker);
                });

                // Only open info window and center map if manually triggered (not auto-calculate)
                if (!autoCalculate) {
                    infoWindow.open(map.value!, marker);
                    map.value!.setCenter(center);
                    map.value!.setZoom(Math.max(map.value!.getZoom() || 10, 10));
                }

                setTimeout(() => {
                    if (marker.getAnimation() !== null) {
                        marker.setAnimation(null);
                    }
                }, 2000);
            }
        }
    );
}

// Clear all markers - Google Maps recommended approach
function clearAllMarkers(): void {
    // 1️⃣ Clear clusterer FIRST
    if (markerCluster.value) {
        markerCluster.value.clearMarkers();
        markerCluster.value = null;
    }

    // 2️⃣ Remove markers from map
    markers.value.forEach(marker => {
        marker.setMap(null);
    });

    // 3️⃣ Reset marker array
    markers.value = [];

    // 4️⃣ Clear center marker if it exists
    if (centerMarker.value) {
        centerMarker.value.setMap(null);
        centerMarker.value = null;
    }
    if (centerInfoWindow.value) {
        centerInfoWindow.value.close();
        centerInfoWindow.value = null;
    }
}

// Clear all markers and reset stats
function clearMap(): void {
    clearAllMarkers();
    updateStats(0, 0, 0);
    errors.value = [];
}

// Delete a specific location
function deleteLocation(locationToDelete: Location): void {
    if (!confirm(`Are you sure you want to delete this location?\n${locationToDelete.address}${locationToDelete.date ? ` (${locationToDelete.date})` : ''}`)) {
        return;
    }

    // Remove from savedLocations
    const locationKey = `${locationToDelete.address.toLowerCase()}_${locationToDelete.date || ''}`;
    savedLocations.value = savedLocations.value.filter(loc => 
        `${loc.address.toLowerCase()}_${loc.date || ''}` !== locationKey
    );

    // Remove marker from map
    const markerToRemove = markers.value.find(m => {
        const markerLoc = (m as any).locationData;
        return markerLoc && 
               markerLoc.address.toLowerCase() === locationToDelete.address.toLowerCase() &&
               markerLoc.date === locationToDelete.date;
    });

    if (markerToRemove) {
        markerToRemove.setMap(null);
        markers.value = markers.value.filter(m => m !== markerToRemove);
        
        // Update marker cluster if it exists
        if (markerCluster.value) {
            markerCluster.value.removeMarker(markerToRemove);
        }
    }

    // Update stats
    const currentMappedCount = markers.value.length;
    updateStats(savedLocations.value.length, currentMappedCount, 0);
    
    // Update localStorage
    saveLocationsToStorage();
}

// Update statistics
function updateStats(total: number, mapped: number, failed: number): void {
    totalCount.value = total;
    mappedCount.value = mapped;
    failedCount.value = failed;
}

// Update progress
function updateProgress(current: number, total: number, message?: string): void {
    const percent = total > 0 ? Math.round((current / total) * 100) : 0;
    progressPercent.value = percent;
    progressText.value = message || `Processing ${current} of ${total}...`;
}

// Geocode a single address
function geocodeAddress(address: string, date: string | null = null): Promise<Location> {
    return new Promise((resolve, reject) => {
        if (!geocoder.value) {
            reject({ address, date, status: 'GEOCODER_NOT_INITIALIZED' });
            return;
        }

        geocoder.value.geocode({ address }, (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
            if (status === 'OK' && results && results[0]) {
                const locationType = results[0].geometry.location_type;
                // Only accept precise location types
                if (locationType === 'ROOFTOP' || locationType === 'RANGE_INTERPOLATED') {
                    resolve({
                        address,
                        date,
                        location: results[0].geometry.location,
                        formatted: results[0].formatted_address
                    });
                } else {
                    reject({
                        address,
                        date,
                        status: 'APPROXIMATE_LOCATION'
                    });
                }
            } else {
                reject({
                    address,
                    date,
                    status: status || 'UNKNOWN_ERROR'
                });
            }
        });
    });
}

// Parse CSV file
function parseCSV(csvText: string): AddressWithDate[] {
    const lines = csvText.split('\n').filter(line => line.trim().length > 0);
    if (lines.length === 0) {
        throw new Error('CSV file is empty');
    }

    // Try to detect header row
    const firstLine = lines[0].toLowerCase();
    const hasHeader = firstLine.includes('date') && firstLine.includes('address');
    const startIndex = hasHeader ? 1 : 0;

    const addresses: AddressWithDate[] = [];
    for (let i = startIndex; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) continue;

        // Parse CSV line (handle quoted fields)
        const parts: string[] = [];
        let current = '';
        let inQuotes = false;

        for (let j = 0; j < line.length; j++) {
            const char = line[j];
            if (char === '"') {
                inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
                parts.push(current.trim());
                current = '';
            } else {
                current += char;
            }
        }
        parts.push(current.trim());

        if (parts.length >= 2) {
            const date = parts[0].trim();
            const address = parts.slice(1).join(',').trim();
            
            if (date && address) {
                addresses.push({ date, address });
            }
        }
    }

    return addresses;
}

// Process addresses with batching and rate limiting
async function processAddresses(addresses: (string | AddressWithDate)[]): Promise<void> {
    const total = addresses.length;
    let mapped = 0;
    let failed = 0;
    const errorList: GeocodeError[] = [];
    const locations: Location[] = [];

    isProcessing.value = true;
    updateStats(total, 0, 0);

    // Process in batches to avoid overwhelming the API
    const batchSize = 10;
    const delayBetweenBatches = 100; // ms

    for (let i = 0; i < addresses.length; i += batchSize) {
        const batch = addresses.slice(i, i + batchSize);
        const promises = batch.map(addrObj => {
            const address = typeof addrObj === 'string' ? addrObj.trim() : addrObj.address.trim();
            const date = typeof addrObj === 'string' ? null : addrObj.date;
            
            return geocodeAddress(address, date)
                .then(result => {
                    mapped++;
                    locations.push(result);
                    updateProgress(i + batch.indexOf(addrObj) + 1, total, `Geocoding: ${result.formatted}`);
                    return result;
                })
                .catch(error => {
                    failed++;
                    errorList.push(error);
                    updateProgress(i + batch.indexOf(addrObj) + 1, total, `Ignored: ${error.address.substring(0, 50)}...`);
                    return null;
                });
        });

        await Promise.all(promises);
        updateStats(total, mapped, failed);

        // Small delay between batches to respect rate limits
        if (i + batchSize < addresses.length) {
            await new Promise(resolve => setTimeout(resolve, delayBetweenBatches));
        }
    }

    // Add markers to map
    updateProgress(total, total, 'Adding markers to map...');
    await addMarkersToMap(locations);

    errors.value = errorList;
    isProcessing.value = false;
    updateStats(total, mapped, failed);

    // Save locations to JSON automatically (avoid duplicates)
    if (locations.length > 0) {
        const existingKeys = new Set(savedLocations.value.map(loc => 
            `${loc.address.toLowerCase()}_${loc.date || ''}`
        ));
        const newLocations = locations.filter(loc => 
            !existingKeys.has(`${loc.address.toLowerCase()}_${loc.date || ''}`)
        );
        
        if (newLocations.length > 0) {
            savedLocations.value = savedLocations.value.concat(newLocations);
            saveLocationsToStorage();
            
            if (newLocations.length < locations.length) {
                const duplicates = locations.length - newLocations.length;
                console.log(`Skipped ${duplicates} duplicate location(s)`);
            }
        }
    }
}

// Get filtered locations by date
function getFilteredLocations(locations: Location[], filter: DateFilter): Location[] {
    if (!filter.startDate || !filter.endDate) {
        return locations;
    }

    const start = new Date(filter.startDate);
    const end = new Date(filter.endDate);
    end.setHours(23, 59, 59, 999);

    return locations.filter(loc => {
        if (!loc.date) return false;
        // Parse date - handle MM/DD/YYYY format
        const dateStr = loc.date.toString();
        let locDate: Date;
        
        if (dateStr.includes('/')) {
            // MM/DD/YYYY format
            const parts = dateStr.split('/');
            if (parts.length === 3) {
                locDate = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
            } else {
                locDate = new Date(dateStr);
            }
        } else {
            locDate = new Date(dateStr);
        }
        
        return !isNaN(locDate.getTime()) && locDate >= start && locDate <= end;
    });
}

// Add markers to map with clustering (optionally filtered by date)
async function addMarkersToMap(locations: Location[], dateFilter: DateFilter | null = null): Promise<void> {
    // Clear all existing markers first
    clearAllMarkers();

    if (!map.value) return;

    // Filter by date if filter is active
    let filteredLocations = locations;
    if (dateFilter?.startDate && dateFilter?.endDate) {
        filteredLocations = getFilteredLocations(locations, dateFilter);
    }

    filteredLocations.forEach((loc, index) => {
        const position = loc.location;
        // Create unique ID for this location
        const locationId = `${loc.address.toLowerCase()}_${loc.date || ''}_${index}`;

        const marker = new google.maps.Marker({
            position: position,
            map: map.value!,
            title: loc.address + (loc.date ? ` (${loc.date})` : ''),
            animation: google.maps.Animation.DROP
        });

        // Add info window with delete button
        const dateInfo = loc.date ? `<br><strong>Date:</strong> ${loc.date}` : '';
        const deleteButtonId = `delete-btn-${locationId.replace(/[^a-z0-9]/gi, '-')}`;
        const infoWindowContent = `
            <div style="padding: 8px; min-width: 200px;">
                <div style="margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #e0e0e0;">
                    <strong style="color: #333; font-size: 14px; display: block; margin-bottom: 4px;">Address:</strong>
                    <span style="color: #333; font-size: 14px; display: block; margin-bottom: 4px;">${loc.address}</span>
                    <small style="color: #666; font-size: 12px; display: block;">${loc.formatted}</small>${dateInfo}
                </div>
                <button 
                    id="${deleteButtonId}" 
                    style="
                        background: #dc3545; 
                        color: white; 
                        border: none; 
                        border-radius: 4px; 
                        padding: 6px 12px; 
                        cursor: pointer; 
                        font-size: 12px;
                        width: 100%;
                    "
                    onmouseover="this.style.background='#c82333'"
                    onmouseout="this.style.background='#dc3545'"
                >
                    Delete Marker
                </button>
            </div>
        `;
        
        const infoWindow = new google.maps.InfoWindow({
            content: infoWindowContent
        });

        marker.addListener('click', (_event: google.maps.MapMouseEvent) => {
            infoWindow.open(map.value!, marker);
            
            // Add delete button listener after info window opens
            setTimeout(() => {
                const deleteBtn = document.getElementById(deleteButtonId);
                if (deleteBtn) {
                    deleteBtn.addEventListener('click', () => {
                        deleteLocation(loc);
                        infoWindow.close();
                    });
                }
            }, 100);
        });

        // Store location reference with marker
        (marker as any).locationData = loc;
        markers.value.push(marker);
    });

    // Create clusterer AFTER markers exist
    if (typeof window.MarkerClusterer !== 'undefined' && markers.value.length > 0) {
        markerCluster.value = new window.MarkerClusterer({
            map: map.value,
            markers: markers.value
        });
    }

    // Fit map to show filtered markers
    if (filteredLocations.length > 0) {
        const bounds = new google.maps.LatLngBounds();
        filteredLocations.forEach(loc => {
            bounds.extend(loc.location);
        });
        map.value.fitBounds(bounds);
    }

    // Auto-calculate and show center location after markers are loaded
    if (markers.value.length > 0) {
        // Small delay to ensure markers are fully rendered
        setTimeout(() => {
            showCenterLocation(true);
        }, 500);
    }
}

// Save locations to JSON file
function saveLocationsToJSON(): void {
    if (savedLocations.value.length === 0) {
        alert('No locations to save. Please map some addresses first.');
        return;
    }

    const locationsToSave = savedLocations.value.map(loc => ({
        address: loc.address,
        formatted: loc.formatted,
        date: loc.date || null,
        lat: loc.location.lat(),
        lng: loc.location.lng()
    }));

    // Prompt for file name
    const fileName = prompt('Enter a name for this file (or leave blank for default):', '');
    const finalFileName = fileName?.trim() || `locations-${new Date().toISOString().split('T')[0]}`;
    const sanitizedFileName = finalFileName.replace(/[^a-z0-9]/gi, '-').toLowerCase();

    // Save to saved files list
    saveToSavedFiles(sanitizedFileName, locationsToSave);

    // Download file
    const json = JSON.stringify(locationsToSave, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${sanitizedFileName}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    // Refresh saved files list
    refreshSavedFiles();
}

// Save locations to localStorage as backup
function saveLocationsToStorage(): void {
    const locationsToSave = savedLocations.value.map(loc => ({
        address: loc.address,
        formatted: loc.formatted,
        date: loc.date || null,
        lat: loc.location.lat(),
        lng: loc.location.lng()
    }));
    localStorage.setItem('geomapper_locations', JSON.stringify(locationsToSave));
}

// Load locations from JSON file
async function loadLocationsFromJSON(file: File): Promise<void> {
    if (!apiKey.value.trim()) {
        alert('Please enter your Google Maps API Key first.');
        return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
        try {
            const result = e.target?.result as string;
            const locations = JSON.parse(result);
            if (!Array.isArray(locations)) {
                throw new Error('JSON file must contain an array of locations');
            }

            // Load Google Maps if not already loaded
            if (!window.google || !window.google.maps) {
                await loadGoogleMaps(apiKey.value);
            }

            // Initialize map if not already initialized
            if (!map.value) {
                initMap();
            }

            // Convert JSON locations back to format with LatLng objects
            const loadedLocations: Location[] = locations.map((loc: any) => ({
                address: loc.address,
                formatted: loc.formatted,
                date: loc.date || null,
                location: new google.maps.LatLng(loc.lat, loc.lng)
            }));

            savedLocations.value = loadedLocations;
        // Reset filters when loading new data
        selectedYear.value = '';
        startDate.value = '';
        endDate.value = '';
        currentDateFilter.value = null;
            await addMarkersToMap(loadedLocations);
            updateStats(loadedLocations.length, loadedLocations.length, 0);
            saveLocationsToStorage();

        // Save to saved files list if not already saved
        const fileName = file.name.replace(/\.json$/i, '').trim() || `imported-${Date.now()}`;
        saveToSavedFiles(fileName, locations);
        refreshSavedFiles();

            alert(`Loaded ${loadedLocations.length} locations from JSON file.`);
        } catch (error: any) {
            alert('Error loading JSON file: ' + error.message);
        }
    };
    reader.readAsText(file);
}

// Load locations from localStorage on page load
async function loadLocationsFromStorage(): Promise<void> {
    if (!apiKey.value.trim()) {
        return;
    }

    const stored = localStorage.getItem('geomapper_locations');
    if (stored) {
        try {
            const locations = JSON.parse(stored);
            if (Array.isArray(locations) && locations.length > 0) {
                if (confirm(`Found ${locations.length} saved locations. Load them now?`)) {
                    if (!window.google || !window.google.maps) {
                        await loadGoogleMaps(apiKey.value);
                    }

                    if (!map.value) {
                        initMap();
                    }

                    const loadedLocations: Location[] = locations.map((loc: any) => ({
                        address: loc.address,
                        formatted: loc.formatted,
                        date: loc.date || null,
                        location: new google.maps.LatLng(loc.lat, loc.lng)
                    }));

                    savedLocations.value = loadedLocations;
                    // Reset filters when loading new data
                    selectedYear.value = '';
                    startDate.value = '';
                    endDate.value = '';
                    currentDateFilter.value = null;
                    await addMarkersToMap(loadedLocations);
                    updateStats(loadedLocations.length, loadedLocations.length, 0);
                    saveLocationsToStorage();
                }
            }
        } catch (error) {
            console.error('Error loading from localStorage:', error);
        }
    }
}

// Load locations for a specific year
async function loadLocationsForYear(year: string): Promise<void> {
    if (!apiKey.value.trim()) {
        return;
    }

    try {
        // Load data directly from year-specific JSON file (no API calls)
        const locations = yearDataMap[year];
        if (!Array.isArray(locations) || locations.length === 0) {
            console.warn(`No data found for year ${year}`);
            return;
        }

        // Load Google Maps JavaScript library (not the geocoding API)
        if (!window.google || !window.google.maps) {
            await loadGoogleMaps(apiKey.value);
        }

        // Initialize map if not already initialized
        if (!map.value) {
            initMap();
        }

        // Convert JSON locations to Location objects using pre-geocoded lat/lng
        // NO API CALLS - just using data from JSON file
        const loadedLocations: Location[] = locations.map((loc: any) => ({
            address: loc.address,
            formatted: loc.formatted,
            date: loc.date || null,
            location: new google.maps.LatLng(loc.lat, loc.lng) // Using lat/lng from JSON
        }));

        // Save locations for this year (replace, don't append)
        savedLocations.value = [...loadedLocations];
        
        // Set filter to the selected year
        selectedYear.value = year;
        startDate.value = '';
        endDate.value = '';
        currentDateFilter.value = {
            startDate: `${year}-01-01`,
            endDate: `${year}-12-31`
        };
        
        // Clear map and add only the selected year's locations (no date filter needed since we're loading only that year)
        await addMarkersToMap(loadedLocations, null);
        updateStats(loadedLocations.length, loadedLocations.length, 0);
        saveLocationsToStorage();
        
        console.log(`Loaded ${loadedLocations.length} locations from customers${year}.json (no API calls)`);
    } catch (error: any) {
        console.error(`Error loading customers${year}.json:`, error);
    }
}

// Auto-load 2026 data on page start
async function loadLocationsFromAllCustomers(): Promise<void> {
    await loadLocationsForYear('2026');
}

// Load a local JSON file by name
async function handleLoadLocalJsonFile(fileName: string): Promise<void> {
    if (!apiKey.value.trim()) {
        alert('Please enter your Google Maps API Key first.');
        return;
    }

    const file = localJsonFiles.value.find(f => f.name === fileName);
    if (!file) {
        alert('File not found');
        return;
    }

    try {
        const locations = file.data;
        if (!Array.isArray(locations) || locations.length === 0) {
            alert('No locations found in this file.');
            return;
        }

        // Load Google Maps if not already loaded
        if (!window.google || !window.google.maps) {
            await loadGoogleMaps(apiKey.value);
        }

        // Initialize map if not already initialized
        if (!map.value) {
            initMap();
        }

        // Convert JSON locations back to format with LatLng objects
        const loadedLocations: Location[] = locations.map((loc: any) => ({
            address: loc.address,
            formatted: loc.formatted,
            date: loc.date || null,
            location: new google.maps.LatLng(loc.lat, loc.lng)
        }));

        savedLocations.value = loadedLocations;
        // Reset filters when loading new data
        selectedYear.value = '';
        startDate.value = '';
        endDate.value = '';
        currentDateFilter.value = null;
        await addMarkersToMap(loadedLocations);
        updateStats(loadedLocations.length, loadedLocations.length, 0);
        saveLocationsToStorage();

        alert(`Loaded ${loadedLocations.length} locations from "${fileName}".`);
    } catch (error: any) {
        alert('Error loading file: ' + error.message);
    }
}

// Event handlers
async function handleMapAddresses(): Promise<void> {
    if (!apiKey.value.trim()) {
        alert('Please enter your Google Maps API Key');
        return;
    }

    if (!addressesText.value.trim()) {
        alert('Please enter at least one address');
        return;
    }

    const addresses = addressesText.value.split('\n').filter(addr => addr.trim().length > 0);

    if (addresses.length === 0) {
        alert('Please enter at least one address');
        return;
    }

    try {
        if (!window.google || !window.google.maps) {
            await loadGoogleMaps(apiKey.value);
        }

        if (!map.value) {
            initMap();
            loadLocationsFromStorage();
        }

        await processAddresses(addresses);
    } catch (error: any) {
        alert('Error: ' + error.message);
    }
}

function handleClearMap(): void {
    clearAllMarkers();
    savedLocations.value = [];
    localStorage.removeItem('geomapper_locations');
    updateStats(0, 0, 0);
    errors.value = [];
}

function handleSaveToJson(): void {
    saveLocationsToJSON();
}

function handleLoadFromJson(): void {
    jsonFileInput.value?.click();
}

function handleJsonFile(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (file) {
        if (!map.value) {
            alert('Please enter your API key and initialize the map first.');
            return;
        }
        loadLocationsFromJSON(file);
    }
    target.value = '';
}

function handleCsvFile(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;

    if (!apiKey.value.trim()) {
        alert('Please enter your Google Maps API Key first.');
        target.value = '';
        return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
        try {
            const result = e.target?.result as string;
            const addresses = parseCSV(result);

            if (addresses.length === 0) {
                alert('No valid addresses found in CSV file.');
                target.value = '';
                return;
            }

            try {
                if (!window.google || !window.google.maps) {
                    await loadGoogleMaps(apiKey.value);
                }

                if (!map.value) {
                    initMap();
                    loadLocationsFromStorage();
                }

                await processAddresses(addresses);
            } catch (error: any) {
                alert('Error processing CSV: ' + error.message);
            } finally {
                target.value = '';
            }
        } catch (error: any) {
            alert('Error parsing CSV: ' + error.message);
            target.value = '';
        }
    };
    reader.readAsText(file);
}

async function handleApplyDateFilter(): Promise<void> {
    if (!startDate.value || !endDate.value) {
        alert('Please select both start and end dates.');
        return;
    }

    if (new Date(startDate.value) > new Date(endDate.value)) {
        alert('Start date must be before or equal to end date.');
        return;
    }

    currentDateFilter.value = {
        startDate: startDate.value,
        endDate: endDate.value
    };

    // Load all relevant JSON files based on date range
    await loadLocationsByDateRange(startDate.value, endDate.value);
}

// Load locations from JSON files based on date range
async function loadLocationsByDateRange(startDateStr: string, endDateStr: string): Promise<void> {
    if (!apiKey.value.trim()) {
        return;
    }

    try {
        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);
        endDate.setHours(23, 59, 59, 999);

        // Determine which years/files to load based on date range
        const startYear = startDate.getFullYear();
        const endYear = endDate.getFullYear();
        
        // Load Google Maps JavaScript library if needed
        if (!window.google || !window.google.maps) {
            await loadGoogleMaps(apiKey.value);
        }

        // Initialize map if not already initialized
        if (!map.value) {
            initMap();
        }

        // Collect all locations from relevant year files
        const allLocations: any[] = [];
        
        // Iterate through all years in the range
        for (let year = startYear; year <= endYear; year++) {
            const yearKey = year.toString();
            
            // Check if we need to load 2025a or 2025b
            if (year === 2025) {
                // Load both halves of 2025
                if (yearDataMap['2025a']) {
                    allLocations.push(...yearDataMap['2025a']);
                }
                if (yearDataMap['2025b']) {
                    allLocations.push(...yearDataMap['2025b']);
                }
            } else if (yearDataMap[yearKey]) {
                // Load the year's data
                allLocations.push(...yearDataMap[yearKey]);
            }
        }

        // Convert to Location objects
        const loadedLocations: Location[] = allLocations.map((loc: any) => ({
            address: loc.address,
            formatted: loc.formatted,
            date: loc.date || null,
            location: new google.maps.LatLng(loc.lat, loc.lng)
        }));

        // Filter by date range
        const dateFilter: DateFilter = {
            startDate: startDateStr,
            endDate: endDateStr
        };
        
        const filteredLocations = getFilteredLocations(loadedLocations, dateFilter);

        // Update savedLocations with filtered data
        savedLocations.value = filteredLocations;
        
        // Clear year selection when using date filter
        selectedYear.value = '';
        
        // Add markers to map with date filter
        await addMarkersToMap(filteredLocations, dateFilter);
        updateStats(filteredLocations.length, filteredLocations.length, 0);
        saveLocationsToStorage();
        
        console.log(`Loaded ${filteredLocations.length} locations from date range ${startDateStr} to ${endDateStr}`);
    } catch (error) {
        console.error('Error loading locations by date range:', error);
        alert('Error loading locations: ' + (error as Error).message);
    }
}

async function handleClearDateFilter(): Promise<void> {
    startDate.value = '';
    endDate.value = '';
    currentDateFilter.value = null;
    selectedYear.value = '';
    // Reload default (2026) when clearing date filter
    await loadLocationsFromAllCustomers();
}

// Get location count for a specific year
function getYearLocationCount(year: string): number {
    if (yearDataMap[year] && Array.isArray(yearDataMap[year])) {
        return yearDataMap[year].length;
    }
    return 0;
}

// Format year label for display (e.g., "2025a" -> "2025 (First Half)", "2025b" -> "2025 (Second Half)")
function formatYearLabel(year: string): string {
    if (year === '2025a') {
        return '2025 (First Half)';
    } else if (year === '2025b') {
        return '2025 (Second Half)';
    }
    return year;
}


// Handle year filter change - updates URL and refreshes page
function handleYearFilterChange(): void {
    const year = selectedYear.value;
    
    // Update URL with year parameter and refresh page
    router.push({ 
        path: '/geomapper', 
        query: { year: year } 
    }).then(() => {
        // Refresh the page to clear everything
        window.location.reload();
    });
}

// Save to saved files list
function saveToSavedFiles(name: string, data: any[]): void {
    const savedFilesList = getSavedFilesFromStorage();
    const newFile: SavedFile = {
        id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
        name: name,
        timestamp: Date.now(),
        locationCount: data.length,
        data: data
    };
    savedFilesList.push(newFile);
    localStorage.setItem('geomapper_saved_files', JSON.stringify(savedFilesList));
    savedFiles.value = savedFilesList;
}

// Get saved files from localStorage
function getSavedFilesFromStorage(): SavedFile[] {
    const stored = localStorage.getItem('geomapper_saved_files');
    if (stored) {
        try {
            return JSON.parse(stored);
        } catch (error) {
            console.error('Error parsing saved files:', error);
            return [];
        }
    }
    return [];
}

// Refresh saved files list
function refreshSavedFiles(): void {
    savedFiles.value = getSavedFilesFromStorage().sort((a, b) => b.timestamp - a.timestamp);
}

// Format date for display
function formatDate(timestamp: number): string {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined });
}

// Quick load a saved file
async function handleQuickLoad(fileId: string): Promise<void> {
    const file = savedFiles.value.find(f => f.id === fileId);
    if (!file) {
        alert('File not found');
        return;
    }

    if (!apiKey.value.trim()) {
        alert('Please enter your Google Maps API Key first.');
        return;
    }

    try {
        // Load Google Maps if not already loaded
        if (!window.google || !window.google.maps) {
            await loadGoogleMaps(apiKey.value);
        }

        // Initialize map if not already initialized
        if (!map.value) {
            initMap();
        }

        // Convert JSON locations back to format with LatLng objects
        const loadedLocations: Location[] = file.data.map((loc: any) => ({
            address: loc.address,
            formatted: loc.formatted,
            date: loc.date || null,
            location: new google.maps.LatLng(loc.lat, loc.lng)
        }));

        savedLocations.value = loadedLocations;
        // Reset filters when loading new data
        selectedYear.value = '';
        startDate.value = '';
        endDate.value = '';
        currentDateFilter.value = null;
            await addMarkersToMap(loadedLocations);
            updateStats(loadedLocations.length, loadedLocations.length, 0);
            saveLocationsToStorage();

        alert(`Loaded ${loadedLocations.length} locations from "${file.name}".`);
    } catch (error: any) {
        alert('Error loading file: ' + error.message);
    }
}

// Download a saved file
function handleDownloadSavedFile(fileId: string): void {
    const file = savedFiles.value.find(f => f.id === fileId);
    if (!file) {
        alert('File not found');
        return;
    }

    const json = JSON.stringify(file.data, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${file.name}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

// Delete a saved file
function handleDeleteSavedFile(fileId: string): void {
    if (!confirm('Are you sure you want to delete this saved file?')) {
        return;
    }

    const savedFilesList = getSavedFilesFromStorage();
    const filtered = savedFilesList.filter(f => f.id !== fileId);
    localStorage.setItem('geomapper_saved_files', JSON.stringify(filtered));
    refreshSavedFiles();
}

onMounted(async () => {
    // Load MarkerClusterer library
    const clusterScript = document.createElement('script');
    clusterScript.src = 'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js';
    document.head.appendChild(clusterScript);
    
    // Wait for API key to load from Firebase, then load default data (2026)
    if (isLoadingApiKey.value) {
        // Wait for API key to be loaded
        const checkApiKey = setInterval(() => {
            if (!isLoadingApiKey.value && apiKey.value.trim() && !hasLoadedInitialData.value) {
                clearInterval(checkApiKey);
                loadMapData();
            }
        }, 100);
        
        // Timeout after 5 seconds
        setTimeout(() => {
            clearInterval(checkApiKey);
            if (apiKey.value.trim() && !hasLoadedInitialData.value) {
                loadMapData();
            } else if (!apiKey.value.trim()) {
                console.warn('API key not loaded from Firebase, will retry when available');
            }
        }, 5000);
    } else if (apiKey.value.trim() && !hasLoadedInitialData.value) {
        // API key already loaded, load data immediately
        await loadMapData();
    } else {
        // API key not loaded yet, wait for it via watch
        // The watch on googleApiKey will trigger loadMapData when key becomes available
    }
});

async function loadMapData(): Promise<void> {
    // Prevent multiple loads
    if (hasLoadedInitialData.value) {
        return;
    }
    
    // Get year from URL parameter
    const yearParam = route.query.year as string;
    
    if (apiKey.value.trim()) {
        hasLoadedInitialData.value = true; // Mark as loaded before async operation
        
        if (yearParam && yearParam !== '') {
            // Load specific year from URL
            selectedYear.value = yearParam;
            await loadLocationsForYear(yearParam);
        } else {
            // Default: load 2026 (no year param in URL)
            selectedYear.value = '2026';
            await loadLocationsFromAllCustomers();
        }
    }
}


onUnmounted(() => {
    // Cleanup if needed
    clearMap();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "menu-header",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (userSettingsOpen.value = !userSettingsOpen.value))
        }, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(userSettingsOpen.value ? '−' : '+'), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
                  style: {"width":"100%","padding":"8px","border":"1px solid #ddd","border-radius":"4px"}
                }, null, 512), [
                  [_vModelText, startDate.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
                  style: {"width":"100%","padding":"8px","border":"1px solid #ddd","border-radius":"4px"}
                }, null, 512), [
                  [_vModelText, endDate.value]
                ])
              ]),
              _createElementVNode("div", { style: {"display":"flex","gap":"8px"} }, [
                _createElementVNode("button", {
                  onClick: handleApplyDateFilter,
                  style: {"flex":"1","padding":"8px","background":"#4285f4","color":"white","border":"none","border-radius":"4px","cursor":"pointer","font-size":"12px"}
                }, " Apply Filter "),
                _createElementVNode("button", {
                  onClick: handleClearDateFilter,
                  style: {"flex":"1","padding":"8px","background":"#dc3545","color":"white","border":"none","border-radius":"4px","cursor":"pointer","font-size":"12px"}
                }, " Clear ")
              ])
            ])
          ]),
          (uniqueYears.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueYears.value, (year) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: year,
                      class: "radio-label"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        value: year,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedYear).value = $event)),
                        onChange: handleYearFilterChange
                      }, null, 40, _hoisted_16), [
                        [_vModelRadio, selectedYear.value]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(formatYearLabel(year)) + " (" + _toDisplayString(getYearLocationCount(year)) + " Locations)", 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, userSettingsOpen.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: "menu-header",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (developerSettingsOpen.value = !developerSettingsOpen.value))
        }, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, _toDisplayString(developerSettingsOpen.value ? '−' : '+'), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _withDirectives(_createElementVNode("textarea", {
              id: "addresses",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addressesText).value = $event)),
              placeholder: "123 Main St, New York, NY 10001\n456 Oak Ave, Los Angeles, CA 90001\n789 Pine Rd, Chicago, IL 60601"
            }, null, 512), [
              [_vModelText, addressesText.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("input", {
              type: "file",
              id: "csvFileInput",
              accept: ".csv",
              onChange: handleCsvFile,
              style: {"margin-bottom":"10px","width":"100%","padding":"8px","border":"2px solid #ddd","border-radius":"6px"}
            }, null, 32),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              id: "mapBtn",
              class: "btn-primary",
              onClick: handleMapAddresses,
              disabled: isProcessing.value
            }, _toDisplayString(isProcessing.value ? 'Processing...' : 'Map Addresses'), 9, _hoisted_27),
            _createElementVNode("button", {
              id: "clearBtn",
              class: "btn-secondary",
              onClick: handleClearMap
            }, " Clear Map ")
          ]),
          _createElementVNode("div", {
            class: "button-group",
            style: {"margin-bottom":"20px"}
          }, [
            _createElementVNode("button", {
              id: "saveBtn",
              class: "btn-secondary",
              onClick: handleSaveToJson
            }, " Save to JSON "),
            _createElementVNode("button", {
              id: "loadBtn",
              class: "btn-secondary",
              onClick: handleLoadFromJson
            }, " Load from JSON ")
          ]),
          _createElementVNode("input", {
            type: "file",
            id: "jsonFileInput",
            accept: ".json",
            ref_key: "jsonFileInput",
            ref: jsonFileInput,
            onChange: handleJsonFile,
            style: {"display":"none"}
          }, null, 544),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            (localJsonFiles.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, " No JSON files found in this folder. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localJsonFiles.value, (file, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.name,
                      class: "saved-file-item",
                      style: {"display":"flex","justify-content":"space-between","align-items":"center","padding":"8px","margin-bottom":"6px","background":"#f9f9f9","border-radius":"4px","border":"1px solid #e0e0e0"}
                    }, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(file.name), 1),
                        _createElementVNode("div", _hoisted_34, _toDisplayString(file.locationCount) + " locations ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("button", {
                          class: "btn-primary",
                          style: {"padding":"4px 10px","font-size":"11px"},
                          onClick: ($event: any) => (handleLoadLocalJsonFile(file.name))
                        }, " Load ", 8, _hoisted_36)
                      ])
                    ]))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("span", _hoisted_40, _toDisplayString(totalCount.value), 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("span", _hoisted_43, _toDisplayString(mappedCount.value), 1)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("span", _hoisted_46, _toDisplayString(failedCount.value), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["progress", { active: isProcessing.value }])
          }, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("span", _hoisted_49, _toDisplayString(progressPercent.value) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", {
                class: "progress-fill",
                style: _normalizeStyle({ width: progressPercent.value + '%' })
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_51, _toDisplayString(progressText.value), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["error-log", { active: errors.value.length > 0 }])
          }, [
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedErrors.value, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "error-item"
                }, _toDisplayString(error.address) + _toDisplayString(error.status === 'APPROXIMATE_LOCATION' ? ' (location too approximate)' : ' (not found)'), 1))
              }), 128)),
              (errors.value.length > 50)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, " ... and " + _toDisplayString(errors.value.length - 50) + " more ignored ", 1))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 512), [
          [_vShow, developerSettingsOpen.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", {
        id: "map",
        ref_key: "mapContainer",
        ref: mapContainer
      }, null, 512),
      _createElementVNode("div", { class: "zoom-controls" }, [
        _createElementVNode("button", {
          class: "zoom-btn",
          onClick: zoomIn,
          title: "Zoom In"
        }, _hoisted_57),
        _createElementVNode("button", {
          class: "zoom-btn",
          onClick: zoomOut,
          title: "Zoom Out"
        }, _hoisted_59),
        _createElementVNode("button", {
          class: "zoom-btn fit-btn",
          onClick: fitToMarkers,
          title: "Fit to Markers"
        }, _hoisted_61),
        _createElementVNode("button", {
          class: "zoom-btn center-btn",
          onClick: handleShowCenterLocation,
          title: "Show Center Location"
        }, _hoisted_63)
      ])
    ])
  ]))
}
}

})